const { Auth } = require("aws-amplify");
const { Buffer } = require("buffer");
const DateUtil = require("./DateUtil")
const AppLog = require("./AppLog")

class UserInfo {
  // static async getCurrentUserGroup() {
  //   try {
  //     let session = await Auth.currentSession();
  //     const jwtToken = session.idToken.jwtToken;
  //     const tokens = jwtToken.split(".");
  //     const tokenBody = Buffer.from(tokens[1], "base64").toString();
  //     let json = JSON.parse(tokenBody);

  //     if (json["cognito:groups"]) {
  //       return json["cognito:groups"];
  //     }
  //   } catch (e) {
  //     return "";
  //   }
  //   return "";
  // }
  // static async getGroup() {
  //   const user = await Auth.currentAuthenticatedUser()
  //   return user.signInUserSession.accessToken.payload["cognito:groups"]
  // }
  /**
   * ユーザー情報を取得する
   * @param {*} time 
   * @returns 
   */
  static async getUserInfo(time = 0) {
    let result = null
    try {
      
      let session = await Auth.currentSession();
      let group = ""
      const groups = session.idToken.payload["cognito:groups"]
      if (groups.length > 0) {
        group = groups[0]
      }
      const userSub = session.idToken.payload.sub
      const email = session.idToken.payload.email
      
      return {
        userName: email,
        sub: userSub,
        group: group,
      }

    } catch (e) {
      if (time < 5) {
        const nextTime = time + 1
        console.log(`UserInfo Error リトライ ${JSON.stringify(result)}`)
        setTimeout(async function() {
          await UserInfo.getUserInfo(nextTime)
        }.bind(this), 100)

      } else {
        throw e
      }
    }
    
  }
  /**
   * ログインセッションの有効期限チェック
   * ※exp期限を迎えるとAuth.currentSession()のたびに更新される。
   * Cognitoの設定で更新Tokenの期限を60分とし、更新トークン期限切れによるログアウトが可能か検証する
   */
  // static async checkTokenExpired() {
  //   let session = await Auth.currentSession();
  //   let credentials = await Auth.currentUserCredentials();
    
  //   //let json = JSON.parse(Buffer.from(credentials.sessionToken, "base64").toString());
  //   // console.log(`checkTokenExpired session:${JSON.stringify(session, null, "\t")}`)
  //   AppLog.debugLog("UserInfo", "", `checkTokenExpired session:${JSON.stringify(session, null, "\t")}`)

  //   if (!session) {
  //     // console.log(`checkTokenExpired セッション情報無し`)
  //     AppLog.debugLog("UserInfo", "", `checkTokenExpired セッション情報無し`)
  //     return false
  //   }
  //   if (!session.accessToken){
  //     // console.log(`checkTokenExpired アクセストークン無し`)
  //     AppLog.debugLog("UserInfo", "", `checkTokenExpired アクセストークン無し`)
  //     return false
  //   }
  //   const expiredTime = session.accessToken.payload.exp
  //   const currentTimestamp = DateUtil.getUnixTimeStampOfSecond()
  //   // console.log(`checkTokenExpired currentTimestamp:${currentTimestamp} expiredTime:${expiredTime}`)
  //   AppLog.debugLog("UserInfo", "", `checkTokenExpired currentTimestamp:${currentTimestamp} expiredTime:${expiredTime}`)
  //   if (currentTimestamp > expiredTime) {
  //     // console.log(`checkTokenExpired 期限切れ`)
  //     AppLog.debugLog("UserInfo", "", `checkTokenExpired 期限切れ`)
  //     return false
  //   }
  //   // console.log(`checkTokenExpired 期限内`)
  //   AppLog.debugLog("UserInfo", "", `checkTokenExpired 期限内`)
  //   return true
  // }
}

module.exports = UserInfo;
